import "./header.css"
import check from "../../pages/task/check.svg";
import SlotCounter from "react-slot-counter";
import React from "react";
import {usePumpStore} from "../../store/pumpStore"
import {levels} from "../../helpers/levelHelpers";
import addIcon from "./assets/add.svg"
import coin from "../../assets/coin.svg"

const Header = () => {
    const {screen, setScreen, balance, tasksCount, level, status, screenLayout, setScreenLayout, setShowArtDialog, showArtDialog} = usePumpStore()
    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    return (
        <header className={`header ${status === 'wait' && '_accent'}`}>
            <div style={{padding: '0 20px', display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%"}}>
            <div style={{width: 85}}>{screenLayout !== 'profile' ? <div className="ellipse" onClick={() => {setScreenLayout('profile');setShowArtDialog('')}} style={{backgroundImage: 'url('+levels[level].active+')'}} /> : <div className="pump-btn" onClick={() => {if (screenLayout === 'profile') {
                if (showArtDialog === '') {
                    setScreenLayout('task')
                } else {
                    setShowArtDialog('')
                }
            } else if (screenLayout === 'balance' || screenLayout === 'create' || showArtDialog !== '') {
                setScreenLayout('profile'); setShowArtDialog('')
            } }}><div className={"text"}>PUMP</div></div>}</div>
            <div className="header__balance" style={{height: 62, display: "flex", alignItems: "center", justifyContent: "center"}} onClick={() => {setScreenLayout('balance')}}>
                <div className="header__balance-number" style={{display: "flex", alignItems: "center", justifyContent: "center"}}><img src={coin} alt={''} style={{height: 26, marginRight: 5}}/> <SlotCounter value={numberWithCommas(parseFloat(balance).toFixed(2)).toString()} separatorClassName={"sep"} /></div>
            </div>
                {(screenLayout !== 'profile' && screenLayout !== 'create' && screenLayout !== 'createForm') ?
                        <div className="header__tasks">
                            <div className="header__tasks-completed">
                                <div className="header__tasks-completed_number">{tasksCount}</div>
                                <img className="header__tasks-completed_icon" alt="Vector" src={check} />
                            </div>
                        </div>
                    :   <div className="header__tasks">
                            <div className="header__tasks-create" onClick={() => {setScreenLayout('create')}}>
                                <img className="header__tasks-create_icon" alt="Vector" src={addIcon} />
                            </div>
                        </div>
                }
            </div>
        </header>
    )
}

export default Header;